import { useEffect, useState } from "react"
import { reasonCodesEN, reasonCodesMN, multipleReasonCode } from "../utils/Utils"
import { useTranslation } from "react-i18next"
import axiosInstance, { portInUseForAPI } from "../api/axiosInstance"
import { filter } from "lodash"


const ReasonCodeList = ({ reasonCodeValue, setreasonCodeValue, type = 'common', category = "Ship_Week",setErrorMessage, setReasonMessage }) => {
    const { t } = useTranslation()

    const [reason_codes, setReasonCode] = useState([])
    const { ReasonCode, Selectareason } = t('ConfirmPOpage')
    // changed reason code validation for divert confirm and quntitty 29/10/24
    // useEffect(() => {
    //     const handleStorage = () => {
    //         if (window.localStorage?.getItem('language') === 'en') {
    //             setReasonCode(reasonCodesEN)
    //         } else {
    //             setReasonCode(reasonCodesMN)
    //         }
    //     }

    //     window.addEventListener('storage', handleStorage())
    //     return () => window.removeEventListener('storage', handleStorage())
    // }, [window.localStorage?.getItem('language')])
    useEffect(() => {
        const filteredReasonCode = multipleReasonCode?.filter((data) => data?.type === type)

        // https://poconnectsit.harborfreight.com:8088/api/reasoncodes/reasonCodeList?crType=Delay&reasonCategory=Ship_Week
        axiosInstance.get(`${process.env.REACT_APP_API_DOMAIN}:${portInUseForAPI}/api/reasoncodes/reasonCodeList?crType=${type}&reasonCategory=${category}`
        ).then((res) => {
            setReasonCode(res?.data || [])
        }).catch((err) => {

        })

    }, [type, category])



    const setSelectedReason = (e) => {
        const selectedreason = reason_codes?.find((i) => {
            return Number(e) === Number(i?.reasonCodeId)
        })
        setreasonCodeValue(selectedreason)
        setErrorMessage?.('')
        setReasonMessage?.('')
    }
    return (
        <div className='w-full flex flex-col items-start gap-2'>

            <label
                htmlFor='reason_code_select'
                className='text-xs font-medium'
            >
                {ReasonCode}
            </label>
            <select
                onChange={(e) => setSelectedReason(e.target.value)}
                name='reason_code_select'
                id='reason_code_select'
                className='p-2 rounded-md outline-none border border-gray-300 text-xs w-full font-medium'
                value={reasonCodeValue?.reasonCodeId}
            >
                <option value='' disabled>
                    {Selectareason}
                </option>
                {reason_codes?.map((reason) => {

                    // <option key={reason?.value} value={window.localStorage?.getItem('language') === 'en'?reason?.reasonEN:reason.reasonMN}>
                    //     {window.localStorage?.getItem('language') === 'en'?reason?.reasonEN:reason.reasonMN}
                    // </option>
                    return < option key={reason?.reasonCodeId} value={reason?.reasonCodeId}>
                        {reason?.reasonCodeText}
                    </option>
                })}
            </select>

        </div >
    )
}
export default ReasonCodeList

export const ReasonCodeView = ({ reasonCodeValue, setreasonCodeValue }) => {
    return (
        <div className='w-full flex flex-wrap justify-center items-center '>
            {reasonCodeValue?.reasonCodeText?.length > 0 && <div
                className='rounded-lg bg-[#4472C4] flex  gap-2 justify-center items-center p-2 text-xs text-white font-medium'
            >
                <span>{reasonCodeValue?.reasonCodeText}</span>
                <span
                    className='cursor-pointer'
                    onClick={() =>
                        setreasonCodeValue('')
                    }
                >
                    X
                </span>
            </div>}
        </div>
    )
}